import axios from "@/api/axiosInstance";
import {
  DataEnvelope,
  Enrollment,
} from "@/modules/learningCenter/features/CourseDirectory/types/viewer";

// Set the caller's resume pointer (last-accessed module) for one of their own
// enrollments.
export const updateLastAccessed = async (
  enrollmentUuid: string,
  moduleUuid: string,
): Promise<Enrollment> => {
  const response = await axios.patch<DataEnvelope<Enrollment>>(
    `/api/private/learning-center/enrollments/${enrollmentUuid}/last-accessed`,
    { moduleUuid },
  );
  return response.data.data;
};
